import { FC } from 'react'

import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { MODULE_ADDRESS } from 'config'

import { useCommonConnectStore } from 'components/WalletProvider/store'
import { cx } from 'utils/cx'

import s from './s.module.scss'

type Props = {
  disabled: boolean
  onLoading?: (loading: boolean) => void
  setError: (error: boolean) => void
  setReceivedClaim: (isClaim: boolean) => void
}

const ClaimButton: FC<Props> = ({ disabled, onLoading, setError, setReceivedClaim }) => {
  const client = useCommonConnectStore((state) => state.client)
  const { account, signAndSubmitTransaction } = useWallet()

  const onClaim = async () => {
    if (typeof onLoading === 'function') onLoading(true)
    const response = await signAndSubmitTransaction({
      data: {
        function: `${MODULE_ADDRESS}::claim::claim`,
        functionArguments: [],
        typeArguments: [],
      },
      sender: account.address,
    }).catch(() => {
      setError(true)
      setReceivedClaim(false)
      if (typeof onLoading === 'function') onLoading(false)
    })
    await client
      .waitForTransaction(response?.hash)
      .then(() => {
        setReceivedClaim(true)
      })
      .catch(() => {
        setError(true)
        setReceivedClaim(false)
      })
      .finally(() => {
        if (typeof onLoading === 'function') onLoading(false)
      })
  }

  return (
    <button className={cx(s.buttonClaim, disabled && s.buttonClaimDisable)} disabled={disabled} onClick={onClaim}>
      Claim
    </button>
  )
}

export default ClaimButton
